var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.758 7.242c2.334 2.336 2.302 6.082.014 8.382l-.014.015-2.625 2.625c-2.315 2.315-6.082 2.315-8.397 0-2.315-2.315-2.315-6.082 0-8.397l1.45-1.45c.384-.384 1.046-.129 1.066.415.025.692.15 1.387.379 2.06.077.227.022.478-.148.648l-.511.511c-1.095 1.095-1.13 2.878-.046 3.983 1.095 1.116 2.894 1.123 3.998.02l2.625-2.625c1.1-1.1 1.096-2.88 0-3.977-.145-.145-.29-.257-.404-.335-.164-.112-.264-.295-.272-.493-.015-.412.131-.838.457-1.164l.823-.822c.215-.216.554-.242.804-.068.286.2.554.425.801.672zm5.506-5.506c-2.315-2.315-6.082-2.315-8.397 0L7.242 4.361l-.014.015c-2.288 2.3-2.32 6.046.014 8.382.247.247.515.472.801.672.25.174.589.148.804-.068l.823-.822c.326-.326.472-.752.457-1.164-.008-.198-.108-.38-.272-.493-.113-.078-.259-.19-.404-.335-1.096-1.096-1.1-2.876 0-3.977l2.625-2.625c1.103-1.103 2.903-1.096 3.997.02 1.084 1.105 1.05 2.888-.045 3.983l-.51.511c-.17.17-.226.421-.149.649.23.672.354 1.367.379 2.06.02.542.682.798 1.066.414l1.45-1.45c2.315-2.315 2.315-6.082 0-8.397z",
    transform: "translate(2 2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.e38f41e1b816791fdc393d6f6aa231a8.svg";
export { ForwardRef as ReactComponent };